import { Component, OnDestroy, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subscription, timer } from "rxjs";
import { UnsavedWorkService } from "src/app/main/services/unsaved-work.service";

@Component({
  selector: "app-idle-timeout-modal",
  templateUrl: "./idle-timeout-modal.component.html",
  styleUrls: ["./idle-timeout-modal.component.scss"],
  standalone: false,
})
export class IdleTimeoutModalComponent implements OnInit, OnDestroy {
  logoutTimerSubscription: Subscription;

  constructor(
    public activeModal: NgbActiveModal,
    public unsavedWorkService: UnsavedWorkService,
  ) {}

  ngOnInit() {
    this.startFormInstance();
  }

  ngOnDestroy() {
    this.logoutTimerSubscription?.unsubscribe();
  }

  extendSession() {
    this.close("extend");
  }

  logout() {
    this.close("logout");
  }

  close(reason: string) {
    this.activeModal.close(reason);
  }

  public startFormInstance() {
    this.logoutTimerSubscription = timer(30000).subscribe({
      next: () => {
        this.close("logged-out");
      },
    });
  }
}
